import { useMemo, useState } from 'react'

import { form } from '../formState'

import { Order } from './Order'
import { OrderStep } from './OrderStep'
import { OrderStepTypeDivision } from './OrderStepTypeDivision'

import * as OrderTexts from '../../../../intl'
import { useCarryLocationOnTypeChange } from '../hooks/useCarryLocationOnTypeChange'
import { PickupAndDeliveryDivisionOption } from '../typings'
import { OrderFormValues, FormProps as Props } from '../typings'
import { getOrderTypeVisibility } from '../utils/getOrderTypeVisibility'

export const Form = (props: Props) => {
  const { maxTagsCount, initialValues } = props
  const [selectedPDOrderStep, setSelectedPDOrderStep] = useState<'p' | 'd'>('p')

  useCarryLocationOnTypeChange()

  const type = form.useFormField('type').field.value
  const pickup = form.useFormField('pickup').field.value
  const delivery = form.useFormField('delivery').field.value
  const orderStepType = form.useFormField('orderStep.type').field.value

  const { type: initialType } = initialValues as OrderFormValues

  const { pickupAndDeliveryFromStart, showPickupAndDelivery, showPickup, showDelivery } =
    getOrderTypeVisibility(initialType, type)

  const showOrderStepPickup =
    showPickup ||
    (pickupAndDeliveryFromStart && orderStepType === 'p') ||
    (!pickupAndDeliveryFromStart && showPickupAndDelivery && selectedPDOrderStep === 'p')

  const showOrderStepDelivery =
    showDelivery ||
    (pickupAndDeliveryFromStart && orderStepType === 'd') ||
    (!pickupAndDeliveryFromStart && showPickupAndDelivery && selectedPDOrderStep === 'd')

  const OrderStepTypeDivisionOptions = useMemo<PickupAndDeliveryDivisionOption[]>(
    () => [
      {
        label: OrderTexts.getOrderTypePickupText(),
        value: 'p',
        disabled: pickupAndDeliveryFromStart && orderStepType === 'd',
      },
      {
        label: OrderTexts.getOrderTypeDeliveryText(),
        value: 'd',
        disabled: pickupAndDeliveryFromStart && orderStepType === 'p',
      },
    ],
    [pickupAndDeliveryFromStart, orderStepType],
  )

  return (
    <>
      <Order {...props} type={type} />

      {showPickupAndDelivery && (
        <OrderStepTypeDivision
          onChange={(value: 'p' | 'd') => setSelectedPDOrderStep(value)}
          value={showOrderStepPickup ? 'p' : showOrderStepDelivery ? 'd' : selectedPDOrderStep}
          options={OrderStepTypeDivisionOptions}
        />
      )}

      {showOrderStepPickup && (
        <OrderStep
          {...props}
          orderStepType="pickup"
          orderStep={pickup!}
          maxTagsCount={maxTagsCount}
          showLastRuler={showPickupAndDelivery}
        />
      )}

      {showOrderStepDelivery && (
        <OrderStep
          {...props}
          orderStepType="delivery"
          maxTagsCount={maxTagsCount}
          orderStep={delivery!}
        />
      )}
    </>
  )
}
